export default "__VITE_ASSET__LA6Yv$Mm__"